var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrderSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5762 0.0197144C4.81207 0.0197144 0.0959473 4.73583 0.0959473 10.5C0.0959473 16.2641 4.81207 20.9802 10.5762 20.9802C16.3404 20.9802 21.0565 16.2641 21.0565 10.5C21.0565 4.73583 16.3404 0.0197144 10.5762 0.0197144ZM14.9779 8.71833L9.94739 13.7489C9.52818 14.1681 8.89937 14.1681 8.48016 13.7489L6.1745 11.4432C5.75529 11.024 5.75529 10.3952 6.1745 9.97596C6.59371 9.55675 7.22253 9.55675 7.64174 9.97596L9.21378 11.548L13.5107 7.2511C13.9299 6.83188 14.5587 6.83188 14.9779 7.2511C15.3971 7.67031 15.3971 8.29912 14.9779 8.71833Z",
    fill: "#24DE9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderSuccess);
export default __webpack_public_path__ + "static/media/iconOrderSuccess.09e7fa1ff64b55035190b1f5a4d18dde.svg";
export { ForwardRef as ReactComponent };